import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { SessionProvider } from './session/SessionProvider';

/**
 * One query client for the application.
 *
 * Nothing is retried by default. A denied row comes back as an empty result
 * rather than an error, so a retry would only ever repeat a real failure —
 * and on a data-protection path a silent second attempt is not a kindness.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </QueryClientProvider>
  );
}
